import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import type { SubTasksViewProps } from '../schema';
import AddSubtaskView from './AddSubtaskView';
import SubTaskDraggableView from './SubTaskDraggableView';

export default observer(function SubTasksView({
    taskId,
    subtasks,
    newSubtaskRef,
    disableSubtasks,
}: SubTasksViewProps) {
    return (
        <div className={styles.subtasksView}>
            {subtasks?.map(subtask => {
                const { Id, IsCompleted, Subject } = subtask;
                return (
                    <SubTaskDraggableView
                        key={Id}
                        parentTaskId={taskId}
                        subtaskId={Id}
                        subject={Subject}
                        isComplete={IsCompleted}
                    />
                );
            })}
            <AddSubtaskView
                newSubtaskRef={newSubtaskRef}
                taskId={taskId}
                disableSubtasks={disableSubtasks}
            />
        </div>
    );
});
